const useStyles = theme => ({
    largeVideoPreviewBoxContainer: {
      paddingLeft: 10,
      paddingRight: 10
    },
    topRowContainer: {
      marginBottom: 10,
      [theme.breakpoints.up('lg')]: {
      },
      [theme.breakpoints.only('md')]: {
        marginTop: 20,
      },
      [theme.breakpoints.down('sm')]: {
        marginTop: 10,
        marginBottom: 0,
      },
    },
    bottomRowContainer: {
      marginTop: 10,
      [theme.breakpoints.up('lg')]: {
      },
      [theme.breakpoints.only('md')]: {
        marginTop: 10,
      },
      [theme.breakpoints.down('sm')]: {
      },
    },

});

export default useStyles
